// type : [ 'processing','prepayment']

import { getDirectusInstance } from './auth.js';

export function getCRMURL() {

        return {
                t: localStorage.getItem("crm_auth_token"),
                u: process.env.CRM_URL
        };
}
async function getCRM(path, token, signal = null, responseType = 'json') {
        const fetchOptions = {
                method: "GET",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        };
        
        if (signal) {
                fetchOptions.signal = signal;
        }
        
        let result = await fetch(`${process.env.CRM_URL}${path}`, fetchOptions);
        if (responseType === 'blob') {
                return result;
        }
        return await result.json();
}

async function deleteCRM(path, token) {
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "DELETE",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });

        return await result.json();
}

async function updateCRM(path, token) {
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "PATCH",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        return await result.json();
}

export async function getGreeners(path, token, responseType = 'json') {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "GET",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        if (responseType === 'blob') {
                return result;
        }
        return await result.json();
}

export async function postGreeners(path, token, body) {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "POST",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(body)
        });
        return await result.json();
}

export async function patchGreeners(path, token, body) {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "PATCH",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(body)
        });
        return await result.json();
}

export async function deleteGreeners(path, token) {
        let result = await fetch(`${process.env.GREENERS_URL}${path}`, {
                method: "DELETE",
                headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                },
        });
        const text = await result.text();
        return text ? JSON.parse(text) : {};
}

export async function postCRM(path, token, body, isFormData = false) {
        let headers = {
                "Authorization": `Bearer ${token}`,
        };
        if (!isFormData) {
                headers["Content-Type"] = "application/json";
        }
        let result = await fetch(`${process.env.CRM_URL}${path}`, {
                method: "POST",
                headers,
                body: isFormData ? body : JSON.stringify(body)
        });
        return await result.json();
}


export async function getOrders(query, type, token = localStorage.getItem("crm_auth_token")) {
        try {

                const args = {
                        dest: 'crm',
                        type: 'orders',
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['date_created'],);

                return await getCRM(`crm/orders/${type}?${queryString}`, token);

        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getImportTask(query, token = localStorage.getItem("crm_auth_token")) {
        try {

                const args = {
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['date_created'],);

                return await getCRM(`import/?${queryString}`, token);

        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getLogsByTaskId(taskId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`import/logs/${taskId}/`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCsvSchemas(pharmacyId, token = localStorage.getItem("crm_auth_token")) {
    try {
        console.log('getCsvSchemas called with pharmacyId:', pharmacyId);
        const directus = getDirectusInstance();
        const schemas = await directus.items('csv_schemas').readByQuery({
            filter: {
                user_created: { _eq: pharmacyId }
            },
            fields: ['id', 'name', 'schema_json'],
            sort: ['name']
        });
        console.log('getCsvSchemas response:', schemas);
        return schemas.data || [];
    } catch (e) {
        console.log('getCsvSchemas error:', e);
        return [];
    }
}


export async function getOrderItems(id, token = localStorage.getItem("crm_auth_token")) {
        if (!id) return [];
        try {
                return await getCRM(`order-items/order/${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getDoneOrdersCount(ordersId = [], user_created, orderSource = "BW",  token = localStorage.getItem("crm_auth_token")) {
        if (!ordersId?.length) return [];
        try {
                return await postCRM(`crm/orders/count`, token, {
                        filter: JSON.stringify({
                                _and: [
                                        { status: { _nin: ["sent", "cancellation"] } },
                                        { external_order_id: { _nin: ordersId } },
                                        { user_created: user_created },
                                        { source: orderSource }
                                ]
                        }),
                });
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCachedProductInventory(query, endpoint = 'all', token = localStorage.getItem("crm_auth_token")) {
        const args = {
                type: query.type,
                limit: query.limit,
                page: null,
                filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
        };

        args.dest = 'crm';

        if (args.limit === -1) {
                delete args['page'];
        }

        let queryString = new URLSearchParams(args).toString();
        queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['name'],);

        return await getCRM(`greeners-cache/read/${endpoint}?${queryString}`, token);

}

export async function getProductInventory(query, endpoint = 'list', token = localStorage.getItem('greeners_auth_token')) {

        const args = {
                type: query.type,
                limit: query.limit,
                page: query.page,
                filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
        };
        args.dest = query?.dest ? query?.dest : 'crm';

        if (args.limit === -1) {
                delete args['page'];
        }

        let queryString = new URLSearchParams(args).toString();
        queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['name'],);

        return await getGreeners(`productinventory/${endpoint}?${queryString}`, token);
}


export async function getProductInventoryV2(query, token = localStorage.getItem('greeners_auth_token')) {
        const args = {
                type: query.type,
                limit: query.limit,
                page: query.page,
                filter: query.filter ? JSON.stringify(query.filter) : JSON.stringify({}),
                dest: query.dest ? query.dest : 'crm',
                searchField: query.searchField,
                isStockManagementLogs: query.isStockManagementLogs || false,
        };

        let queryString = new URLSearchParams(args).toString();
        if (query?.sortField && query?.sortOrder)
                queryString += `&sortField=${query.sortField}&sortOrder=${query.sortOrder}`;
        if (query.productsWithInventoryOnly) {
                queryString += `&productsWithInventoryOnly=${query.productsWithInventoryOnly}`;
        }
        if (query.isStockManagementLogs)
                queryString += `&isStockManagementLogs=${query.isStockManagementLogs}`;


        return await getGreeners(`productinventory/list/v2?${queryString}`, token);
}

export async function updateInventoryAndStockLogs(body, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await postGreeners('productinventory/update', token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getStockMgmtReasons(token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners('productinventory/list/stock-management-reasons', token);
}
export async function getFile(id, token = localStorage.getItem('greeners_auth_token')) {
        return await getGreeners(`assets/${id}`, token, 'blob');
}
export async function getProductsByIds(ids, token = localStorage.getItem('greeners_auth_token')) {
        if(!ids || !ids.length) return [];

        let queryString = `ids=${JSON.stringify(ids)}`;
        return await getGreeners(`productinventory/for-product-ids?${queryString}`, token);
}

export async function getProductItem(type, id, token = localStorage.getItem('greeners_auth_token')) {
        let productResult = await getGreeners(`items/${type}/${id}`, token);

        return productResult;
}

function arrayToUrlParameter(key, array) {
        let str = '';
        for (let i = 0; i <= array.length - 1; i++) {
                str += `&${key}[]=${array[i]}`
        }
        return str;
}

export async function getOrderComments(id, token) {
        try {
                return await getCRM(`crm/orders/comments?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

/**
 * This function retrieves the activity log for a specific order using a provided order ID.
 * @param id - The ID of the order for which you want to retrieve the activity log.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API URL.
 * @returns a Promise that resolves to the JSON response from a GET request to the Directus API
 * endpoint for retrieving the activity log of a specific order. The response contains information
 * about the actions taken on the order, such as updates, comments, and status changes. If an error
 * occurs during the request, the function logs the error to the console.
 */
export async function getOrdersActivitylog(id, token) {
        try {
                return await getCRM(`crm/orders/activity?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getOrdersActivitylogV2(id, token) {
  try {
    return await getCRM(`crm/orders/activity/v2?id=${id}`, token);
  } catch (e) {
    console.log(e);
    return [];
  }
}

/**
 * This function retrieves the payment verification state and returns it as a JSON
 * object.
 * @param token - The access token used to authenticate the API request.
 * @returns This function is returning the result of a GET request to the
 * `crm/payment_verification_state` endpoint with an access token passed as a query parameter. The
 * response is expected to be in JSON format, and the function is returning the parsed JSON data. If
 * there is an error, it will be caught and logged to the console.
 */
export async function getPaymentVerificationState(token) {
        try {
                return await getCRM(`crm/payment_verification_state`, token);
        } catch (e) {
                console.log(e);
        }
}

/**
 * This is an asynchronous function that retrieves a single order from a CRM system using an order ID
 * and access token.
 * @param id - The ID of the order that you want to retrieve from the CRM system.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API endpoint URL.
 * @returns the result of the API call to retrieve a single order with the specified orderId and token.
 * The result is expected to be in JSON format. If there is an error, an empty array is returned.
 */
export async function getOrder(id, token) {
        try {
                return await getCRM(`crm/orders/single?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCustomerData(id, token) {
        try {
                return await getCRM(`crm/customer_data/single?id=${id}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getCurrentVersion() {
        try {
                const result = await fetch(`${process.env.CRM_URL}crm/get-current-version`, {
                        method: "GET",
                        headers: {
                                "Content-Type": "application/json",
                        },
                });
                const response = await result.json();
                return response?.version || null;
        } catch (e) {
                console.log(e);
                return null;
        }
}
/**
 * This function retrieves autosuggested customers based on a query.
 * @param query - The `query` parameter is an object that contains a `filter` property. The `filter`
 * property is an object that specifies the filter criteria for the autosuggest query.
 * @param token - The `token` parameter is an access token that is used to authenticate the user making
 * the API request. It is passed as a query parameter in the API URL.
 * @returns the result of a fetch request to a Directus API endpoint for autosuggesting customers based
 * on a given query and access token. The result is expected to be in JSON format. If there is an
 * error, an empty array is returned.
 */
export async function getAutosuggestedCustomers(query, token) {
        try {
                const queryString = new URLSearchParams({
                        filter: JSON.stringify(query.filter),
                }).toString();

                return await getCRM(`crm/customer/autosuggest?${queryString}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function updatePrescriptionOfInventories(body, token) {
        try {
                return await postGreeners(`productinventory/list/inventory/updatePrescriptionProviders`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

const PHARMACY_PROVIDER_SURCHARGE = 'pharmacy_provider_surcharge';

export async function getProviderSurchargeConfig(pharmacyId, token = localStorage.getItem('greeners_auth_token')) {
        try {
                const filter = JSON.stringify({ pharmacy_id: { _eq: pharmacyId } });
                const queryString = new URLSearchParams({
                        filter,
                        fields: 'id,provider_id,surcharge_value,surcharge_unit',
                        limit: -1
                }).toString();
                const result = await getGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}?${queryString}`, token);
                const data = result?.data || [];
                const config = {};
                data.forEach((row) => {
                        const providerId = typeof row.provider_id === 'object' ? row.provider_id?.id : row.provider_id;
                        if (providerId) {
                                config[providerId] = {
                                        id: row.id,
                                        value: row.surcharge_value,
                                        unit: row.surcharge_unit || '%'
                                };
                        }
                });
                return config;
        } catch (e) {
                console.error('Error fetching provider surcharge config:', e);
                return {};
        }
}

export async function createProviderSurcharge(payload, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await postGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}`, token, payload);
        } catch (e) {
                console.error('Error creating provider surcharge:', e);
                throw e;
        }
}

export async function updateProviderSurcharge(id, payload, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await patchGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}/${id}`, token, payload);
        } catch (e) {
                console.error('Error updating provider surcharge:', e);
                throw e;
        }
}

export async function deleteProviderSurcharge(id, token = localStorage.getItem('greeners_auth_token')) {
        try {
                return await deleteGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}/${id}`, token);
        } catch (e) {
                console.error('Error deleting provider surcharge:', e);
                throw e;
        }
}

export async function getExistingProviderSurchargeId(pharmacyId, providerId, token = localStorage.getItem('greeners_auth_token')) {
        try {
                const filter = JSON.stringify({
                        _and: [
                                { pharmacy_id: { _eq: pharmacyId } },
                                { provider_id: { _eq: providerId } }
                        ]
                });
                const queryString = new URLSearchParams({
                        filter,
                        fields: 'id',
                        limit: 1
                }).toString();
                const result = await getGreeners(`items/${PHARMACY_PROVIDER_SURCHARGE}?${queryString}`, token);
                return result?.data?.[0]?.id;

        } catch (e) {
                console.error('Error fetching existing provider surcharge:', e);
                return null;
        }
}

export async function fetchOrderSource(token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`crm/orders/source`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function fetchCustomerGroup(token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`crm/orders/customer/groups`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function abortTask(taskId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await updateCRM(`import/${taskId}`, token);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function uploadCSVFile(data, token = localStorage.getItem("crm_auth_token")) {
        const formData = new FormData();
        formData.append("file", data?.file);
        formData.append("metadata", JSON.stringify(data?.metadata));

        try {
                return await postCRM("import", token, formData, true);
        } catch (error) {
                console.error("File upload failed:", error);
                throw error;
        }
}

export async function cancelPaymentLink(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/cancel-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}

export async function getPaymentLinkStatus(paymentLinkId, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await getCRM(`cardflo/payment-link-status/${paymentLinkId}`, token);
        } catch (e) {
                console.log(e);
                return null;
        }
}

export async function refundOrVoid(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/refund`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
export async function sendPaymentLink(body, token = localStorage.getItem("crm_auth_token")) {
        try {
                return await postCRM(`cardflo/generate-payment-link`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
export async function bulkOrderUpdate(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/bulk-update`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

/** Bulk mark orders paid with today’s date (async task; poll with getBulkOrderStatus + operationType=mark_paid). */
export async function bulkMarkPaidToday(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/bulk-mark-paid`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function getBulkOrderStatus(taskId, token = localStorage.getItem('crm_auth_token'), query = {}) {
        try {
          const queryString = new URLSearchParams(query)?.toString() || '';
          return await getCRM(`order/task/${taskId}?${queryString}`, token);
        } catch (e) {
          console.log(e);
          return [];
        }
}
export async function createProtocolItems(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/protocol-items`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createDeliveryNotes(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/delivery-notes`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createAttachments(body, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await postCRM(`order/attachments`, token, body);
        } catch (e) {
                console.log(e);
                return [];
        }
}
export async function downloadAttachments(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await getCRM(`order/attachments/download/${taskId}`, token, null, 'blob');
        } catch (e) {
                console.log(e);
                return null;
        }
}
export async function deleteAttachments(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                return await deleteCRM(`order/attachments/delete-file/${taskId}`, token);
        } catch (e) {
                console.log(e);
                return null;
        }
}
export async function createBulkDhlLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/dhl-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkUrbifyLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`urbify/bulk-shipment-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkProductLabels(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`order/product-labels`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createBulkInvoices(body, token = localStorage.getItem('crm_auth_token')) {
        try {
          return await postCRM(`cardflo/generate-bulk-invoices`, token, body);
        } catch (e) {
          console.log(e);
          return [];
        }
}

export async function createOrder2_0(orderData, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/create`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(orderData)
                });
                
                if (!response.ok) {
                        // The backend sends the user-facing message directly
                        // (German for inventory failures, real message for
                        // everything else) — surface it as-is.
                        let body = null;
                        try {
                                body = await response.json();
                        } catch (_) {
                                // response body was not JSON
                        }
                        const serverError = body?.errors?.[0];
                        const message =
                                serverError?.message ||
                                body?.message ||
                                `HTTP error! status: ${response.status}`;
                        const err = new Error(message);
                        err.status = response.status;
                        err.code = serverError?.extensions?.code;
                        throw err;
                }

                return await response.json();
        } catch (e) {
                console.error('Error creating order:', e);
                throw e;
        }
}

export async function updateOrder2_0(orderId, orderData, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/update-order/${orderId}`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(orderData)
                });
                
                if (!response.ok) {
                        let body = null;
                        try {
                                body = await response.json();
                        } catch (_) {
                                // response body was not JSON
                        }

                        const serverError = body?.errors?.[0];
                        const code = serverError?.extensions?.code;

                        // The backend sends the user-facing message directly
                        // (German for inventory failures, real message for
                        // everything else) — surface it as-is.
                        const message =
                                serverError?.message ||
                                body?.message ||
                                `HTTP error! status: ${response.status}`;

                        const err = new Error(message);
                        err.status = response.status;
                        err.code = code;
                        throw err;
                }
                return await response.json();
        } catch (e) {
                console.error('Error updating order:', e);
                throw e;
        }
}

export async function getOrderDetails(orderId, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order/${orderId}`, {
                        method: 'GET',
                        headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                }
        });

        if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
        } catch (e) {
                console.error('Error getting order details:', e);
                throw e;
        }
}

export async function getReservedOrdersV2(query, signal = null, token = localStorage.getItem("crm_auth_token")) {
        try {
                const args = {
                        dest: 'crm',
                        type: 'orders',
                        limit: query.limit,
                        page: query.page,
                        filter: query.filter != null ? JSON.stringify(query.filter) : JSON.stringify({}),
                };

                if (args.limit === -1) {
                        delete args['page'];
                }

                let queryString = new URLSearchParams(args).toString();
                queryString += arrayToUrlParameter('sort', query['sort'] != null && typeof query['sort'] != 'undefined' ? query['sort'] : ['-date_created']);

                return await getCRM(`order/orderlist/getReservedOrdersV2?${queryString}`, token, signal);

        } catch (e) {
                if (e.name === 'AbortError') {
                        throw e;
                }
                console.log(e);
                return [];
        }
}

export async function createInvoiceWithEmail(order, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/create-invoice-with-email`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify(order)
                });
                return await response.json();
        } catch (e) {
                console.error('Error creating invoice with email:', e);
                throw e;
        }
}

export async function syncFastbillInvoices(token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/sync-fastbill-invoices`, {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                        }
                });
                return await response.json();
        } catch (e) {
                console.error('Error syncing fastbill invoices:', e);
                throw e;
        }
}

export async function getSyncFastbillInvoicesStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
        try {
                const response = await fetch(`${process.env.CRM_URL}order-items/sync-fastbill-invoices/status/${taskId}`, {
                        headers: {
                          Authorization: `Bearer ${token}`
                        }
                      });
                  
                return await response.json();   
        } catch (error) {
                console.error('Error getting sync fastbill invoices status:', error);
                throw error;
        }
}

export async function processBankTransfers(file, token = localStorage.getItem('crm_auth_token')) {
  try {
    const formData = new FormData();
    formData.append('csv', file);

    const response = await fetch(`${process.env.CRM_URL}order/process-bank-transfers`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    return await response.json();
  } catch (e) {
    console.error('Error processing bank transfers:', e);
    throw e;
  }
}

export async function getBankTransferTaskStatus(taskId, token = localStorage.getItem('crm_auth_token')) {
  try {
    const response = await fetch(`${process.env.CRM_URL}order/bank-transfer-task/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return await response.json();
  } catch (e) {
    console.error('Error getting bank transfer task status:', e);
    throw e;
  }
}

export async function downloadProcessedCSV(filename, token = localStorage.getItem('crm_auth_token')) {
  try {
    const response = await fetch(`${process.env.CRM_URL}order/download-processed-csv/${filename}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  } catch (e) {
    console.error('Error downloading processed CSV:', e);
    throw e;
  }
}

export async function getDeliveryDetails(orderId, queryParams = {}) {
  try {
    const searchParams = new URLSearchParams(queryParams).toString()
    const url = `${process.env.CRM_URL}notifications/delivery/select/${orderId}${searchParams ? `?${searchParams}` : ''}`
    const response = await fetch(url);

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        ok: false,
        data: null,
        error: data?.message || "Unknown error"
      };
    }

    return {
      ok: true,
      data
    };
  } catch (e) {
    console.error("Error getting delivery details:", e);
    return {
      ok: false,
      error: e ||  "Network error"
    };
  }
}

export async function updateDeliveryMethod(orderId, deliveryDetails) {

  try {
    const response = await fetch(`${process.env.CRM_URL}notifications/delivery/update/${orderId}`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body : JSON.stringify(deliveryDetails)
    });

     const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        ok: false,
        data : null,
        error: data?.message || "Unknown error"
      };
    }

    return {
      ok: true,
      data
    };
  } catch (e) {
    return {
      ok: false,
      error: e ||  "Network error"
    };
  }
}

export async function submitMcosPrescriptionResponse(payload) {
	try {
		const response = await fetch(`${process.env.CRM_URL}provider-notifications/mcos-order-answer`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		});

		// parse JSON first (you already do this)
		const data = await response?.json?.().catch(() => null);

		// if the server returned an error status, throw an Error with the API message if present
		if (!response.ok) {
			const errMsg = data?.message || `HTTP error! status: ${response.status}`;
			const err = new Error(errMsg);
			// attach extra info for callers if they want to inspect it
			err.status = response.status;
			err.data = data;
			throw err;
		}

		if (!data?.success) {
			throw new Error(data?.message || 'Request failed');
		}

		return data?.data || {};
	} catch (e) {
		console.error('Error submitting MCOS prescription response:', e);
		throw e;
	}
}

export async function getUrbifyCoverageAPI(postcode, token = localStorage.getItem("crm_auth_token"), isNextDay = false) {
  try {
    const queryString = new URLSearchParams({ serviceType: isNextDay ? 'urbify_next_day' : 'urbify' }).toString();
    const response = await getCRM(`urbify/coverage/${postcode}?${queryString}`, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Urbify API Fehler');
  }
}

export async function getCardFloPayments(dateFrom, dateTo, token = localStorage.getItem("crm_auth_token")) {
  try {
    const queryString = new URLSearchParams({ startDate: dateFrom, endDate: dateTo }).toString();
    return await getCRM(`reports-generation/get-cardflo-payments?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { total: 0 } };
  }
}

export async function getNegativeVirtualAmountOrders(isReserved, token = localStorage.getItem("crm_auth_token")) {
  try {
    const queryString = new URLSearchParams({
      isReserved: String(Boolean(isReserved))
    }).toString();
    return await getCRM(`reports-generation/negative-virtual-amount-orders?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { totalNegativeVirtualAmountProducts: 0 } };
  }
}

export async function getNegativeVirtualAmountOrderDetails(
  inventoryId,
  { sort, order, isReserved } = {},
  token = localStorage.getItem("crm_auth_token")
) {
  try {
    const orderDir = String(order || 'asc').toLowerCase() === 'desc' ? 'desc' : 'asc';
    const queryString = new URLSearchParams({
      inventoryId: String(inventoryId),
      sort: String(sort ?? ''),
      order: orderDir,
      isReserved: String(Boolean(isReserved))
    }).toString();
    return await getCRM(`reports-generation/negative-virtual-amount-order-details?${queryString}`, token);
  } catch (e) {
    console.log(e);
    return { data: [], meta: { total: 0 } };
  }
}
